import { gql } from "@apollo/client";
import moment from "moment";

export const SAVE_PRESENCIAL_AE_CAMBIO_SONDA = gql`
    mutation saveVisitaPresencialAECambioSonda($input: AddVisitaPresencialAECambioSondaPHInput!){
        saveVisitaPresencialAECambioSonda(input: $input) {
            idPresencialAE
        }
    }
`;
export const SAVE_PRESENCIAL_AE_CONTROL_PH = gql`
    mutation saveVisitaPresencialAEControlPH($input: AddVisitaPresencialAECambioSondaPHInput!){
        saveVisitaPresencialAEControlPH(input: $input) {
            idPresencialAE
        }
    }
`;

export const adaptAddVisitaPresencialAECambioSondaPHInput = (data) => ({
  idPresencialAE: data?.idPresencialAE,
  controlUbicacionPH: !!data?.controlUbicacionPH,
  tiempoAyunoPrevio: data?.tiempoAyunoPrevio,
  cantidadMuestraExtraida: data?.cantidadMuestraExtraida,
  tipoSonda: data?.tipoSonda,
  lote: data?.lote,
  vencimientoLote: !!data?.vencimientoLote ? moment(data?.vencimientoLote).format('YYYY-MM-DD') : null,
  aspectoSimilMocoLeche: !!data?.aspectoSimilMocoLeche,
  aspectoSimilLecheCortada: !!data?.aspectoSimilLecheCortada,
  colorLechoso: !!data?.colorLechoso,
  colorRojizo: !!data?.colorRojizo,
  colorNegruzco: !!data?.colorNegruzco,
  autorizaLiquidoAcuoso: !!data?.autorizaLiquidoAcuoso,
  autorizaFilante: !!data?.autorizaFilante,
  autorizaColorAmarronado: !!data?.autorizaColorAmarronado,
  autorizaColorAmarillento: !!data?.autorizaColorAmarillento,
  autorizaColorVerdeOscuro: !!data?.autorizaColorVerdeOscuro
});